import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';

import { DumbPlayerAvatar } from '@sorare/core/src/components/player/DumbPlayerAvatar';

import type { GameplayPlayerAvatar_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  player: GameplayPlayerAvatar_anyPlayer;
} & Pick<ComponentProps<typeof DumbPlayerAvatar>, 'variant'>;

export const PlayerAvatar = ({ player, ...rest }: Props) => {
  return (
    <DumbPlayerAvatar
      name={player.displayName}
      avatarUrl={player.avatarPictureUrl}
      {...rest}
    />
  );
};

PlayerAvatar.fragments = {
  anyPlayer: gql`
    fragment GameplayPlayerAvatar_anyPlayer on AnyPlayerInterface {
      slug
      displayName
      avatarPictureUrl
    }
  ` as TypedDocumentNode<GameplayPlayerAvatar_anyPlayer>,
};
